import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { getAvailableOptions, ALL_PLOT_OPTIONS } from './QuestionChartConfig';
import { capitalize } from './QuestionDataMappers';
import ChartRenderer from './components/ChartRenderer';
import DetailsList from './components/DetailsList';
import MatrixLegend from './components/MatrixLegend';
import PreferenceOrderLegend from './components/PreferenceOrderLegend';
import PointsLegend from './components/PointsLegend';
import SemanticLegend from './components/SemanticLegend';

const ChartOptionsMenu = ({ plotType, setPlotType, availableOptions }) => {
  return (
    <div className="chart-options-menu-wrapper" data-html2canvas-ignore="true">
      <div className="chart-options-menu">
        <div className="menu-title">Gráfico</div>
        {ALL_PLOT_OPTIONS.map(option => {
          const isActive = plotType === option.id;
          const isEnabled = availableOptions.some(opt => opt.id === option.id);
          return (
            <button
              key={option.id}
              className={`menu-item ${isActive ? 'active' : ''}`}
              onClick={() => setPlotType(option.id)}
              disabled={!isEnabled}
              type="button"
            >
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

const QuestionResult = ({ question, index, plotType: propPlotType, setPlotType: propSetPlotType }) => {
  const availableOptions = getAvailableOptions(question);

  // Initialize plotType dynamically to the first available option
  const [localPlotType, setLocalPlotType] = useState(() => {
    const opts = getAvailableOptions(question);
    return opts[0]?.id || 'anillo';
  });

  const plotType = propPlotType !== undefined ? propPlotType : localPlotType;
  const setPlotType = propSetPlotType !== undefined ? propSetPlotType : setLocalPlotType;

  const isSimpleChoice =
    question.questionType !== 'open' &&
    !['matrix', 'semantic_differential', 'points', 'preference_order'].includes(question.responseFormat);

  const isMatrix = question.questionType === 'structured' && question.responseFormat === 'matrix';
  const isPreferenceOrder = question.responseFormat === 'preference_order';
  const isPoints = question.responseFormat === 'points';
  const isSemantic = question.responseFormat === 'semantic_differential';

  return (
    <Card className="survey-result-card w-100 bg-white shadow-sm" id={`question-result-card-${question.id}`}>
      <Card.Body className="d-flex flex-column p-4 h-100" style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center mb-4">
          <span className="survey-question-badge">{index + 1}</span>
          <h5
            className="mb-0 survey-preview-question-title font-weight-bold text-dark"
            style={{ fontSize: '14px', lineHeight: '1.4' }}
          >
            {capitalize(question.label)}
          </h5>
        </div>

        <div className={`survey-result-plot-wrapper ${question.questionType === 'open' ? 'compact-plot' : ''}`}>
          <div className={`chart-plot-area ${plotType === 'table' ? 'table-plot-area' : 'graph-plot-area'}`}>
            <ChartRenderer question={question} plotType={plotType} />
          </div>
        </div>

        <div className="survey-result-bottom-section">
          <div className="survey-result-details-col">
            {plotType !== 'table' && isSimpleChoice && <DetailsList question={question} />}
            {plotType !== 'table' && isMatrix && <MatrixLegend question={question} />}
            {plotType !== 'table' && isPreferenceOrder && <PreferenceOrderLegend question={question} />}
            {plotType !== 'table' && isPoints && <PointsLegend question={question} />}
            {plotType !== 'table' && isSemantic && <SemanticLegend question={question} />}
          </div>
          <ChartOptionsMenu plotType={plotType} setPlotType={setPlotType} availableOptions={availableOptions} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default QuestionResult;
